import { createElement } from 'react';
import styles from './text.module.less';

export const Emphasize = ({ tag = 'em', children }) => createElement(tag, { className: styles.italic }, children);

export const Strong = ({ tag = 'strong', children }) => createElement(tag, { className: styles.bold }, children);
